export const ACCOUNT_MENU_STORAGE_KEY = "vocabularium_account_menu";

export const ACCOUNT_MENU_MODES = {
  LOGOUT: "logout",
  CPANEL: "cpanel",
};

const VALID_MODES = new Set(Object.values(ACCOUNT_MENU_MODES));

export function sanitizeAccountMenuMode(raw) {
  return VALID_MODES.has(raw) ? raw : ACCOUNT_MENU_MODES.LOGOUT;
}

export function readAccountMenuMode() {
  try {
    return sanitizeAccountMenuMode(localStorage.getItem(ACCOUNT_MENU_STORAGE_KEY));
  } catch {
    return ACCOUNT_MENU_MODES.LOGOUT;
  }
}

export function writeAccountMenuMode(mode) {
  const next = sanitizeAccountMenuMode(mode);
  try {
    localStorage.setItem(ACCOUNT_MENU_STORAGE_KEY, next);
  } catch {
    // quota / mode privé : on ignore
  }
  return next;
}
